import Api from "./Api";

export default {
    load(language) {
        return Api.get(`interessents/data/countries?lang=${language}`);
    }
}